"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mapHelpers_1 = require("../map/mapHelpers");
class ExpandOnClick {
    constructor(container, map, baseClass) {
        this.container = container;
        this.map = map;
        this.baseClass = baseClass;
        const expandButtonDesktop = this.container.querySelector(`.${this.baseClass}__expand-icon-desktop`);
        const expandButtonMobile = this.container.querySelector(`.${this.baseClass}__expand-icon-mobile`);
        if (expandButtonDesktop && expandButtonMobile) {
            this.setupExpandClick(expandButtonDesktop, expandButtonMobile);
        }
    }
    setupExpandClick(expandButtonDesktop, expandButtonMobile) {
        [expandButtonDesktop, expandButtonMobile].forEach(element => {
            element.addEventListener('click', () => {
                this.container.classList.toggle('is-expanded');
                (0, mapHelpers_1.invalidateSize)(this.map);
            });
        });
    }
}
exports.default = ExpandOnClick;
